<template>
  <v-container fluid class="pl-md-7 pb-16 mb-10">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-if="!payout.account_created && !loading">
      <h1 class="text-h5 mb-5 mt-5">
        {{ $t("stringN614") }}
      </h1>
      <v-row>
        <v-col cols="12" md="8">
          <v-card elevation="0" class="grey lighten-5 mb-10" max-width="100%">
            <v-card-title class="subtitle-1 red--text">
              {{ $t("stringN615") }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="max-height: 400px; overflow-y: scroll">
              <div class="body-2 pb-3">
                <p>{{ $t("stringN616") }}</p>
                <p>{{ $t("stringN617") }}</p>
                <p>{{ $t("s1647714237") }}</p>
              </div>
              <v-divider></v-divider>
              <div class="overline pt-3 pb-2">{{ $t("stringN618") }}</div>
              <div class="body-2 pb-3">
                <ul>
                  <li class="pb-2">{{ $t("s1647714305") }}</li>
                  <li class="pb-2">{{ $t("s1647714697") }}</li>
                  <li class="pb-2">{{ $t("s1647714728") }}</li>
                  <li class="pb-2">{{ $t("s1647714771") }}</li>
                  <li class="pb-2">{{ $t("s1647714799") }}</li>
                  <li class="pb-2">{{ $t("s1647714831") }}</li>
                </ul>
              </div>
              <v-divider></v-divider>
              <div class="overline pt-3 pb-2">{{ $t("s1647714857") }}</div>
              <div class="body-2 pb-3">
                <ul>
                  <li class="pb-2">{{ $t("s1647715045") }}</li>
                  <li class="pb-2">{{ $t("s1647715088") }}</li>
                  <li class="pb-2">{{ $t("s1647715137") }}</li>
                  <li class="pb-2">{{ $t("s1647715165") }}</li>
                  <li class="pb-2">{{ $t("s1647715199") }}</li>
                </ul>
              </div>
            </v-card-text>
          </v-card>
          <v-select
            v-model="selectedCountry"
            :items="countries"
            item-text="title"
            item-value="code"
            v-if="!editAccount"
            :label="$t('SelectYourCountry')"
            outlined
            :rules="reqRules"
          ></v-select>
        </v-col>
      </v-row>
      <component
        v-if="selectedCountry"
        v-bind:is="currentTabComponent"
        class="tab"
        @changeEdit="changeEdit"
        :accountData="accountData"
      ></component>
    </div>
    <div v-if="payout.account_created && !loading && !editAccount">
      <h1 class="text-h5 mb-0 mt-5">
        {{ $t("Overview") }}
      </h1>
      <v-row v-if="!payout.charges_enabled || !payout.payouts_enabled">
        <v-col cols="8">
          <v-alert prominent type="error">
            <v-row align="center">
              <v-col class="grow pt-0 pb-0">
                <strong>{{ $t("Cmsg33") }}</strong> <br />
                {{ $t("Cmsg34") }}
              </v-col>
              <v-col class="shrink">
                <v-btn @click="editPayout">{{ $t("Takeaction") }}</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="auto">
          <div class="overline">{{ $t("Payments") }}</div>
          <v-chip
            small
            class="mr-2"
            :color="payout.charges_enabled ? 'green' : 'red'"
            outlined
          >
            <v-icon small left> mdi-check-circle </v-icon>
            <span v-if="payout.charges_enabled">{{ $t("Active") }}</span>
            <span v-if="!payout.charges_enabled">{{ $t("Inactive") }}</span>
          </v-chip>
        </v-col>
        <v-col cols="auto">
          <div class="overline">{{ $t("Payouts") }}</div>
          <v-chip
            small
            class="mr-2"
            :color="payout.payouts_enabled ? 'green' : 'red'"
            outlined
          >
            <v-icon small left> mdi-check-circle </v-icon>
            <span v-if="payout.payouts_enabled">{{ $t("Active") }}</span>
            <span v-if="!payout.payouts_enabled">{{ $t("Inactive") }}</span>
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="3" cols="12">
          <v-card
            class="mx-auto light-green lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{
                payout.balance.available[0].amount
                  | zeroDecimalCheck(payout.balance.available[0].currency)
              }}
              <sup class="body-1 text-uppercase">
                {{ payout.balance.available[0].currency }}</sup
              >
            </div>
            <div class="caption pa-5 pt-0">{{ $t("Cmsg31") }}</div>
          </v-card>
        </v-col>
        <v-col md="3" cols="12">
          <v-card
            class="mx-auto light-blue lighten-3 text-center"
            max-width="100%"
            height="100%"
          >
            <div class="text-h4 pt-5">
              {{
                payout.balance.pending[0].amount
                  | zeroDecimalCheck(payout.balance.pending[0].currency)
              }}
              <sup class="body-1 text-uppercase">
                {{ payout.balance.pending[0].currency }}</sup
              >
            </div>
            <div class="caption pa-5 pt-0">{{ $t("Cmsg32") }}</div>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="payout.accountData" class="pb-5 pt-5">
        <h2 class="text-h5 mb-5 mt-5">
          {{ $t("string666") }}
          <AddPayout
            :country="selectedCountry"
            :getConnectAccount="getConnectAccount"
          />
        </h2>
        <v-simple-table>
          <template v-slot:default>
            <thead class="grey lighten-3">
              <tr>
                <th class="text-left">{{ $t("accountHolderName") }}</th>
                <th class="text-left">{{ $t("BankName") }}</th>
                <th class="text-left">{{ $t("AccountNumber") }}</th>
                <th class="text-left">{{ $t("Country") }}</th>
                <th class="text-left">{{ $t("string667") }}</th>
                <th class="text-left"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payout.accountData" :key="item._id">
                <td>{{ item.account_holder_name }}</td>
                <td>{{ item.bank_name }}</td>
                <td>**************{{ item.last4 }}</td>
                <td>{{ item.country }}</td>
                <td>
                  <v-tooltip top v-if="item.default_for_currency">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-bind="attrs"
                        v-on="on"
                        small
                        class="mr-2"
                        color="light-blue"
                        outlined
                      >
                        <v-icon small left> mdi-check-circle </v-icon>
                        <span>{{ $t("string667") }}</span>
                      </v-chip>
                    </template>
                    <span>{{ $t("string668") }}</span>
                  </v-tooltip>
                </td>
                <td>
                  <v-menu offset-y v-if="!item.default_for_currency">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" text v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="() => confirmMakeDefault(item.id)">
                        <v-list-item-title>{{
                          $t("string669")
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="() => confirmDelete(item.id)">
                        <v-list-item-title>{{
                          $t("Delete")
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <div v-if="payout.payments">
        <h2 class="text-h5 mb-5 mt-5">
          {{ $t("string664") }}
        </h2>
        <v-simple-table>
          <template v-slot:default>
            <thead class="grey lighten-3">
              <tr>
                <th class="text-left">{{ $t("PaymentId") }}</th>
                <th class="text-left">{{ $t("Tripid") }}</th>
                <th class="text-left">{{ $t("Amount") }}</th>
                <th class="text-left">{{ $t("CleaningFee") }}</th>
                <th class="text-left">{{ $t("Status") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payout.payments" :key="item._id">
                <td>{{ item.payment_id }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'PartnerBookingViewComponent',
                      params: { id: item.booking_id }
                    }"
                    >{{ item.booking_id }}</router-link
                  >
                </td>
                <td>{{ item.currency_code }} {{ item.amount }}</td>
                <td>{{ item.currency_code }} {{ item.cleaning_fee }}</td>
                <td>{{ item.payment_status }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import zeroDecimalCheck from "@/filters/zeroDecimalCheck.js";
import StripeUSComponent from "@/components/payouts/StripeUSComponent.vue";
import StripeJPComponent from "@/components/payouts/StripeJPComponent.vue";
import PartnerService from "@/services/PartnerService";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import swal from "sweetalert";
import AddPayout from "@/components/payouts/AddPayoutAccount.vue";

export default {
  name: "PayoutComponent",
  mixins: [timeoutMixin],
  filters: { zeroDecimalCheck },
  components: {
    StripeUSComponent,
    StripeJPComponent,
    WaitDialogComponent,
    AddPayout
  },
  data() {
    return {
      loading: true,
      waitDialog: false,
      payout: { account_created: false },
      reqRules: [value => !!value || this.$t("string719")],
      selectedCountry: null,
      editAccount: false,
      countries: [
        { title: "USA", code: "US" },
        { title: "JAPAN", code: "JP" }
      ],
      accountData: {
        firstName: null,
        lastName: null,
        accountNumber: null,
        abartn: null
      }
    };
  },
  computed: {
    currentTabComponent: function() {
      return "Stripe" + this.selectedCountry + "Component";
    }
  },
  created: function() {
    if (this.$store.state.user.role != "Host") {
      this.$router.push({ name: "Dashboard" });
    }
    this.getConnectAccount();
  },
  methods: {
    getConnectAccount() {
      PartnerService.getConnectAccount()
        .then(({ data }) => {
          this.waitDialog = false;
          this.payout = data;
          this.accountData = {
            firstName: data.accountData.firstName,
            lastName: data.accountData.lastName,
            accountNumber: data.accountData.accountNumber,
            abartn: data.accountData.abartn
          };
          this.selectedCountry = data.country;
          this.loading = false;
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err;
          this.loading = false;
        });
    },
    editPayout() {
      this.waitDialog = true;
      PartnerService.editPayout()
        .then(result => {
          window.location.href = result.data.item.url;
          this.waitDialog = false;
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.error;
        });
    },
    changeEdit() {
      this.editAccount = false;
      this.getConnectAccount();
    },
    confirmMakeDefault(externalAccount) {
      swal({
        title: this.$t("string691"),
        text: this.$t("string668"),
        icon: "warning",
        buttons: {
          cancel: this.$t("Cancel"),
          Proceed: {
            text: this.$t("Proceed"),
            value: true
          }
        }
      }).then(proceed => {
        if (proceed) this.makeDefault(externalAccount);
      });
    },
    makeDefault(externalAccount) {
      this.waitDialog = true;
      PartnerService.makeDefaultPayout({ externalAccount })
        .then(() => {
          this.getConnectAccount();
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.error;
        });
    },
    confirmDelete(externalAccount) {
      swal({
        title: this.$t("string691"),
        icon: "error",
        buttons: {
          cancel: "Cancel",
          Proceed: {
            text: this.$t("Proceed"),
            value: true
          }
        }
      }).then(proceed => {
        if (proceed) this.deleteAccount(externalAccount);
      });
    },
    deleteAccount(externalAccount) {
      this.waitDialog = true;
      PartnerService.deleteAccount({ externalAccount })
        .then(() => {
          this.getConnectAccount();
        })
        .catch(err => {
          this.waitDialog = false;
          this.error = err.response.data.error;
        });
    }
  }
};
</script>

<style></style>
